module.exports = __webpack_public_path__ + "img/noticia-23.8911adeb.jpg";